// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"5cf57e75e471db11a92b","655":"f4ca451e204649bc7208"}[chunkId] + ".js";
};